import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  itemSection: FelaCSS;
  itemWrap: FelaCSS;
  iconWrap: FelaCSS;
  text: FelaCSS;
  seeMoreLink: FelaCSS;
}

const styles: IStyles = {
  wrapper: {
    paddingBottom: 4,
    borderBottom: `1px solid ${colors.space15}`,
    desktopDesign: {
      paddingBottom: 0,
      borderBottom: 'none',
    },
  },

  itemSection: {
    flexDirection: 'column',
    desktopDesign: {
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
  },

  itemWrap: {
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'center',
    width: '50%',
    marginTop: 4,

    maxWidthTabletSm: {
      paddingRight: 2,
    },

    maxWidthMobileSm: {
      width: '100%',
    },

    ':nth-of-type(even)': {
      paddingLeft: 3,
      paddingRight: 0,

      maxWidthTabletSm: {
        paddingLeft: 0,
      },
    },
  },

  iconWrap: {
    justifyContent: 'center',
    marginRight: 2,
    height: '16px',
  },

  text: {
    fontDefault: 14,
    lineHeight: '16px',
    color: colors.space,
  },

  seeMoreLink: {
    fontDefault: 14,
    textDecoration: 'underline',
    marginTop: 4,
    cursor: 'pointer',
    color: colors.indigoCrush,
    display: 'inline-block',
    marginHorizontal: 'auto',
  },
};

export default styles;
